import "./style.css";
import { ItemState } from "../../utils/interfaces/packages";
import { Checkbox } from "@mui/material";
import { SetStateAction, useState } from "react";
import Gallery from "../Gallery";

interface ProductListProps {
  products: Array<ItemState>;
  selectItem: (item: ItemState) => void;
  userCount: number;
  subscriptionType: string;
  selectedItems: Array<ItemState>;
  term: string;
  currency: string;
  telligentData?: any;
  contractLength: string;
}

const ProductList = (props: ProductListProps) => {
  const [expandedProductId, setExpandedProductId] = useState<number | null>(
    null
  );
  const [detailedDescData, setDetailedDescData] = useState<any>([]);

  const showFullDescriptionHandler = (
    id: SetStateAction<number | null>,
    sku: string
  ) => {
    setExpandedProductId(expandedProductId === id ? null : id);
    const product = props?.telligentData?.find((p: any) => p?.pid === sku);
    setDetailedDescData([product]);
  };

  const findSubscriptionType = (product: ItemState) => {
    return (
      product.options?.findIndex(
        (item) =>
          item.title === props.subscriptionType ||
          item.title.includes(props.contractLength)
      ) ?? -1
    );
  };

  const isChecked = (product: ItemState) => {
    return (
      props.selectedItems.findIndex((item) => item.sku === product.sku) > -1
    );
  };

  return (
    <>
      {props?.products?.map((product: ItemState) =>
        product.stock_status === "IN_STOCK" ? (
          <div
            key={`product-list-${product.id}`}
            className="product-list-container"
          >
            <Checkbox
              data-track={`product-list-${product.id}`}
              id={`product-list-${product.id}`}
              aria-label="Checkbox"
              checked={isChecked(product)}
              onChange={() => props.selectItem(product)}
            />
            <div>
              <label
                className="cursor-pointer"
                htmlFor={`product-list-${product?.id}`}
              >
                <h3 className="product-name">{product?.name}</h3>
              </label>
              <h3 className="product-name">
                {product.options && (
                  <>
                    {props.currency}
                    {product.options &&
                      product.options[findSubscriptionType(product)]
                        ?.drop_down_option[props.userCount - 1]?.price}
                    /{props.term}
                  </>
                )}
              </h3>
              <div className="product-description-div">
                <p className="product-description">
                  {expandedProductId === product.id ? (
                    <>
                      {" "}
                      <span
                        dangerouslySetInnerHTML={{
                          __html: product?.short_description.html,
                        }}
                      />
                      <div
                        style={{ marginTop: "5px" }}
                        dangerouslySetInnerHTML={{
                          __html: detailedDescData[0]?.detaileddescription,
                        }}
                      />
                      {detailedDescData[0]?.images !== null &&
                      detailedDescData[0]?.images?.length > 0 ? (
                        <Gallery productData={detailedDescData} />
                      ) : null}
                    </>
                  ) : (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: `${product?.short_description?.html.substring(0, 130)}... `,
                      }}
                    />
                  )}
                </p>
                {product?.short_description?.html.length > 100 && (
                  <button
                    data-track={`product-desc-${product.id}`}
                    className="product-btn text-blues-denim"
                    onClick={() =>
                      showFullDescriptionHandler(product?.id, product?.sku)
                    }
                  >
                    {expandedProductId === product?.id ? (
                      <strong> Show less</strong>
                    ) : (
                      <strong> Show more </strong>
                    )}
                  </button>
                )}
              </div>
            </div>
          </div>
        ) : null
      )}
    </>
  );
};

export default ProductList;
